import React from 'react';
import { Modal, Form, InputNumber, Input, Button } from 'antd';

interface Props {
    visible: boolean;
    onCancel: () => void;
    onSubmit: (values: { loginFailedCount: number; newPassword?: string }) => void;
    userEmail: string;
    initialLoginFailedCount: number;
}

const AdminUserEditForm: React.FC<Props> = ({ visible, onCancel, onSubmit, userEmail, initialLoginFailedCount }) => {
    const [form] = Form.useForm();

    React.useEffect(() => {
        form.setFieldsValue({
            loginFailedCount: initialLoginFailedCount,
            newPassword: undefined,
            confirmPassword: undefined,
        });
    }, [initialLoginFailedCount, visible, form]);

    const handleFinish = (values: any) => {
        onSubmit({
            loginFailedCount: values.loginFailedCount ?? 0,
            newPassword: values.newPassword || undefined,
        });
    };

    return (
        <Modal
            open={visible}
            title={`Manage user${userEmail ? ' – ' + userEmail : ''}`}
            onCancel={onCancel}
            footer={null}
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleFinish}
                initialValues={{ loginFailedCount: initialLoginFailedCount }}
            >
                <Form.Item
                    name="loginFailedCount"
                    label="Failed login count"
                    rules={[{ required: true, message: 'Please enter a value' }]}
                >
                    <InputNumber min={0} style={{ width: '100%' }} />
                </Form.Item>
                <Form.Item>
                    <Button onClick={() => form.setFieldsValue({ loginFailedCount: 0 })}>
                        Unlock (reset to 0)
                    </Button>
                </Form.Item>
                <Form.Item
                    name="newPassword"
                    label="New password"
                    extra="Leave blank to keep the current password"
                    rules={[{ min: 8, message: 'Password must be at least 8 characters' }]}
                >
                    <Input.Password autoComplete="new-password" />
                </Form.Item>
                <Form.Item
                    name="confirmPassword"
                    label="Confirm new password"
                    dependencies={['newPassword']}
                    rules={[
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!getFieldValue('newPassword') || getFieldValue('newPassword') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('Passwords do not match'));
                            },
                        }),
                    ]}
                >
                    <Input.Password autoComplete="new-password" />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" style={{ marginRight: 8 }}>
                        Save
                    </Button>
                    <Button onClick={onCancel}>Cancel</Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default AdminUserEditForm;
